import { useMutation } from '@tanstack/react-query'
import { UpdateSimpleMovement } from '../../../infra/requests/LogisticsRequests'
import { QUERY_KEYS } from '../../../infra/constants/QueryKeys'
import useEnsureValidToken from './useEnsureValidToken'


export const useUpdateSimpleMovement = (id) => {
    const { ensureValidToken } = useEnsureValidToken()

    const mutation = useMutation({
        mutationKey: [QUERY_KEYS.UpdateSimpleMovement, id],
        mutationFn: async (payload) => {
            await ensureValidToken()

            return UpdateSimpleMovement(id, payload)
        },
    })

    return {
        updateMovement: mutation.mutate,
        isUpdating: mutation.isPending,
    }
}